import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Switch.css';
import React, { useEffect } from 'react';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import addQueryString, { removeQueryString, splitter } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNil } from '../../utils/IsNil';
var replaceUrlPluses = function replaceUrlPluses() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (str) {
    var arr = str.split('');
    var plusIndexes = [];
    arr.forEach(function (item, index) {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (str.includes('+') && str.includes('%20')) {
      return str.replace(/\%20/g, ' ');
    } else {
      var newStr = str;
      var newStrArr = str.split('');
      plusIndexes.forEach(function (el, i) {
        // 5++days -> 5+ days
        if (el + 1 === plusIndexes[i + 1]) {
          newStrArr[el + 1] = ' ';
          newStr = newStrArr.join('');
          // 1+day -> 1 day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] !== ' ') {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
          // 5+ day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
          return str;
        }
        //business+events;,leisure+events;art+&+events
        else {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
        }
      });
      return newStr;
    }
  }
  return str;
};
var sortFilters = function sortFilters(arr, pinnedArray) {
  if (arr.length !== 0) {
    var sortedArray = arr.map(function (el) {
      return pinnedArray.includes(el.key) ? _objectSpread(_objectSpread({}, el), {}, {
        pinned: true
      }) : el;
    });
    return sortedArray.sort(function (first) {
      return first.pinned ? -1 : 1;
    });
  }
};
export var createFacetsWithPinnedLogic = function createFacetsWithPinnedLogic(facets, pinnedArray) {
  var filteredOptions = [];
  if (facets) {
    filteredOptions = Object.keys(facets).map(function (item) {
      return {
        key: item,
        label: facets[item],
        name: item
      };
    });
  }
  return sortFilters(filteredOptions, pinnedArray);
};
var Switch = function Switch(_ref) {
  var fields = _ref.fields,
    facets = _ref.facets,
    setFilter = _ref.setFilter,
    facetsName = _ref.facetsName,
    selectAllLabel = _ref.selectAllLabel,
    clearAlllFilters = _ref.clearAlllFilters,
    isTagPage = _ref.isTagPage,
    dictionary = _ref.dictionary,
    buttonsDictionary = _ref.buttonsDictionary,
    analytics = _ref.analytics,
    pinned = _ref.pinned,
    setIsTypeSetToUrl = _ref.setIsTypeSetToUrl,
    getFilterValue = _ref.getFilterValue,
    rtl = _ref.rtl,
    resetAllFiltersCallback = _ref.resetAllFiltersCallback,
    autoWidth = _ref.autoWidth;
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var selectedTagsToDisplay = get(fields, 'preselectedTags.values');
  var filterName = get(fields, 'name');
  var _React$useState = React.useState(canUseDOM ? createFacetsWithPinnedLogic(facets, pinned) : []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    filteredOptions = _React$useState2[0],
    setFilteredOptions = _React$useState2[1];
  var filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  var showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  var type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Toggle Single Select' ? 'radio' : 'checkbox';
  var history = useHistory();
  var checkboxes = React.useRef();
  useEffect(function () {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        var preselectedTags = selectedTagsToDisplay.map(function (tag) {
          return get(tag, 'title.value') || get(tag, 'name');
        });
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(preselectedTags.join(',')));
        setFilter();
        resetAllFiltersCallback();
      } else {
        var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
        for (var i = 0; i <= checkboxesArray.length - 1; i++) {
          checkboxesArray[i].checked = false;
        }
        removeQueryString(facetsName, history);
        getFilterValue && getFilterValue(fields.name, facetsName, null);
      }
    }
  }, [clearAlllFilters]);
  useEffect(function () {
    var queries = queryParams["".concat(filterType)];
    if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
      var preselectedTags = selectedTagsToDisplay.map(function (tag) {
        return get(tag, 'title.value') || get(tag, 'name');
      });
      if (!queries) {
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        setFilter(true);
      }
    }
  }, []);
  var addNewQueryString = function addNewQueryString() {
    var queries = queryParams["".concat(filterType)];
    if (!queries && filteredOptions && filteredOptions.length) {
      addQueryString(facetsName, filteredOptions[0].key, history);
      setIsTypeSetToUrl(true);
    }
  };
  var buttonHistoryHandler = function buttonHistoryHandler() {
    var urlParams = new URLSearchParams(canUseDOM ? window.location.search : undefined);
    var typeFromUrl = urlParams.get('type');
    if (isNil(typeFromUrl)) {
      addNewQueryString();
    }
  };
  useEffect(function () {
    addNewQueryString();
  }, [filteredOptions]);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener("popstate", buttonHistoryHandler);
    }
    return function () {
      removeQueryString(facetsName, history);
      window.addEventListener("popstate", buttonHistoryHandler);
    };
  }, []);
  var setChecked = function setChecked(key, filterType, index) {
    var queries = queryParams["".concat(filterType)];
    queries = queries && replaceUrlPluses(queries);
    var isChecked = false;
    if (index === 0 && isTagPage && !queries) {
      addQueryString(facetsName, replaceUrlPluses(key), history);
      setFilter();
      isChecked = true;
    }
    queries && queries.split(';,;').map(function (item) {
      if (replaceUrlPluses(item) === key) {
        isChecked = true;
      }
    });
    return isChecked;
  };
  useEffect(function () {
    setFilteredOptions(createFacetsWithPinnedLogic(facets, pinned));
  }, [facets]);
  var translatedKey = function translatedKey(key) {
    if (isTagPage) {
      return getDictionaryItem(dictionary, "Type.".concat(key));
    } else {
      return getDictionaryItem(buttonsDictionary, key) || key;
    }
  };
  var submitFilters = function submitFilters(e) {
    var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    var selectedCheckboxes = [];
    for (var i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
    setFilter();
    getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(selectedCheckboxes));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    autoWidth: autoWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: "g-checkbox g-checkbox--mob-scroll ".concat(type === 'radio' ? 'g-checkbox-notick' : '')
  }, filteredOptions && filteredOptions.map(function (item, index) {
    var key = item.key;
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, filterType, index),
      checked: setChecked(key, filterType, index),
      type: type,
      className: "fp__checkbox",
      id: "gct1-".concat(key + index),
      name: "gct1",
      title: translatedKey(key),
      onChange: function onChange(e) {
        tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, ": ").concat(key, " "));
        submitFilters(e);
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, ": ").concat(key, " "));
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: "gct1-".concat(key + index)
    }, translatedKey(key)));
  }), showSelectAllOption && /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: selectAllLabel,
    defaultChecked: false,
    type: type,
    className: "select-all-fp__checkbox",
    id: "gct1-select-all",
    name: "selectAll",
    onChange: function onChange(_ref2) {
      var currentTarget = _ref2.currentTarget;
      var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
      var selectedCheckboxes = [];
      for (var i = 0; i <= checkboxesArray.length - 1; i++) {
        checkboxesArray[i].checked = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
      currentTarget.checked = false;
      selectedCheckboxes = selectedCheckboxes.toString();
      addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
      setFilter();
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: "gct1-select-all"
  }, selectAllLabel)))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    _ref3$autoWidth = _ref3.autoWidth,
    autoWidth = _ref3$autoWidth === void 0 ? false : _ref3$autoWidth;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyle : ltrStyle, " ").concat(autoWidth ? "col" : "col-md-12")
  }, children);
};
export default Switch;
export var commonStyles = "cbfjhrm";
var ltrStyle = "l10ug17t";
var rtlStyle = "rkx7avf";